import { COLOR_ALPHAS, COLOR_KEYS, type LayoutTheme } from "./layoutTypes";

function toKebab(str: string): string {
  return str.replace(/([A-Z])/g, "-$1").toLowerCase();
}

function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const h = hex.replace("#", "");
  return {
    r: parseInt(h.substring(0, 2), 16),
    g: parseInt(h.substring(2, 4), 16),
    b: parseInt(h.substring(4, 6), 16),
  };
}

function colorVars(name: string, hex: string): Array<[string, string]> {
  const kebab = toKebab(name);
  const { r, g, b } = hexToRgb(hex);
  const entries: Array<[string, string]> = [[`--vc-${kebab}`, hex]];
  for (const [suffix, alpha] of Object.entries(COLOR_ALPHAS)) {
    entries.push([`--vc-${kebab}-${suffix}`, `rgba(${r},${g},${b},${alpha})`]);
  }
  return entries;
}

function themeToVars(theme: LayoutTheme): Array<[string, string]> {
  const vars: Array<[string, string]> = [];
  for (const [key, value] of Object.entries(theme)) {
    const kebab = toKebab(key);
    if (COLOR_KEYS.includes(key as (typeof COLOR_KEYS)[number])) {
      vars.push(...colorVars(key, value));
    } else {
      vars.push([`--vc-${kebab}`, value]);
    }
  }
  return vars;
}

function themeToStylesheet(theme: LayoutTheme): string {
  const vars = themeToVars(theme)
    .map(([k, v]) => `${k}:${v}`)
    .join(";");
  return `:root{${vars}}`;
}

const STYLE_ID = "vc-theme-vars";

function applyTheme(theme: LayoutTheme): void {
  let style = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
  if (!style) {
    style = document.createElement("style");
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }
  style.textContent = themeToStylesheet(theme);
}

export { applyTheme };
